import React from "react";
import SubNav3 from "./SubNav3";
import MegaNavbar from "./MegaNavbar";
import { Layout } from "antd";
import {
  PhoneOutlined,
  MailOutlined,
  FormOutlined,
  LinkOutlined,
} from "@ant-design/icons";
import FlashnewsHeader from "./Header";

const { Header } = Layout;

/* ─── Design tokens pulled from logo ─── */
const NAVY   = "black";   // deep authority blue
const GOLD   = "#C8991A";   // logo gold band
const CRIMSON= "#B22222";   // logo red
const GOLD_LIGHT = "#F5D97A";

const topBarStyle = {
  backgroundColor: NAVY,
  padding: "6px 32px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  borderBottom: `2px solid ${GOLD}`,
};

const pillStyle = {
  display: "inline-flex",
  alignItems: "center",
  gap: 5,
  color: GOLD_LIGHT,
  fontSize: 12,
  fontFamily: "'Lato', sans-serif",
  textDecoration: "none",
  padding: "3px 10px",
  borderRadius: 3,
  border: "1px solid rgba(200,153,26,0.3)",
  transition: "background 0.2s, color 0.2s",
  letterSpacing: 0.4,
};

const admissionBtnStyle = {
  display: "inline-flex",
  alignItems: "center",
  gap: 6,
  backgroundColor: CRIMSON,
  color: "white",
  fontSize: 12,
  fontWeight: 700,
  fontFamily: "'Lato', sans-serif",
  padding: "5px 16px",
  borderRadius: 4,
  textDecoration: "none",
  letterSpacing: 0.5,
  border: "none",
  cursor: "pointer",
  transition: "background 0.2s",
};

export default class PanduNav extends React.Component {
  constructor(props) {
    super(props);
    this.state = { sticky: false };
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    this.setState({ sticky: window.scrollY > 150 });
  };

  render() {
    return (
      <div style={{ fontFamily: "'Lato', sans-serif" }}>
         

        {/* ══════════════════════════════════════
            TOP UTILITY BAR  (navy + gold)
        ══════════════════════════════════════ */}
        <div style={topBarStyle}>
          {/* Left: institution tagline */}
          <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
            <span style={{ color: GOLD, fontSize: 11, letterSpacing: 1.5, fontWeight: 700, textTransform: "uppercase" }}>
              Affiliated to Gauhati University
            </span>
            <span style={{ color: "rgba(255,255,255,0.25)", fontSize: 14 }}>|</span>
            <span style={{ color: "rgba(255,255,255,0.55)", fontSize: 11, letterSpacing: 0.5 }}>
              NAAC Accredited · Est. 1963
            </span>
          </div>

          {/* Right: quick links */}
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <a style={pillStyle} href="/iqac/about"
              onMouseEnter={e => e.currentTarget.style.background = "rgba(200,153,26,0.15)"}
              onMouseLeave={e => e.currentTarget.style.background = "transparent"}
            >
              <LinkOutlined style={{ fontSize: 10 }} /> IQAC
            </a>
            <a style={pillStyle}
              href="#"
              target="_blank" rel="noreferrer"
              onMouseEnter={e => e.currentTarget.style.background = "rgba(200,153,26,0.15)"}
              onMouseLeave={e => e.currentTarget.style.background = "transparent"}
            >
              <LinkOutlined style={{ fontSize: 10 }} /> Feedback
            </a>
            <a style={pillStyle} href="tel:+913612345678"
              onMouseEnter={e => e.currentTarget.style.background = "rgba(200,153,26,0.15)"}
              onMouseLeave={e => e.currentTarget.style.background = "transparent"}
            >
              <PhoneOutlined style={{ fontSize: 10 }} /> +91 91018 29733
            </a>
            <a style={pillStyle} href="mailto:info@rangiacollege.ac.in"
              onMouseEnter={e => e.currentTarget.style.background = "rgba(200,153,26,0.15)"}
              onMouseLeave={e => e.currentTarget.style.background = "transparent"}
            >
              <MailOutlined style={{ fontSize: 10 }} /> principal.rangiacollege@gmail.com
            </a>
          </div>
        </div>

        {/* ══════════════════════════════════════
            MAIN HEADER  (white, logo + search + CTA)
        ══════════════════════════════════════ */}
        <div
          style={{
            backgroundColor: "#fff",
            borderBottom: `1px solid #e8e0d0`,
            padding: "0 32px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            minHeight: 100,
            boxShadow: "0 2px 12px rgba(26,43,74,0.07)",
          }}
        >
          {/* Logo + College Name */}
          <a href="/" style={{ textDecoration: "none", display: "flex", alignItems: "center", gap: 16 }}>
            <img
              src="/images/rc-logo.png"
              alt="Rangia College Logo"
              style={{ height: 78, width: "auto", objectFit: "contain" }}
            />
            <div style={{ display: "flex", flexDirection: "column", lineHeight: 1.2 }}>
              {/* Assamese / vernacular name */}
              <span style={{
                fontFamily: "Rohini",
                fontSize: 17,
                color: CRIMSON,
                fontWeight: 700,
                letterSpacing: 0.5,
              }}>
                ৰঙিয়া মহাবিদ্যালয়
              </span>
              {/* English name */}
              <span style={{
                fontFamily: "'Playfair Display', Georgia, serif",
                fontSize: 26,
                color: NAVY,
                fontWeight: 700,
                letterSpacing: 0.3,
              }}>
                Rangia College
              </span>
              {/* Gold rule + sub-info */}
              <div style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 3 }}>
                <div style={{ width: 32, height: 2, backgroundColor: GOLD, borderRadius: 1 }} />
                <span style={{
                  fontSize: 11,
                  color: "#6b7280",
                  fontFamily: "'Lato', sans-serif",
                  letterSpacing: 0.8,
                  textTransform: "uppercase",
                }}>
                  Kamrup, Assam — Gauhati University
                </span>
              </div>
            </div>
          </a>

          {/* Centre: Google Search */}
          <div style={{ flex: "0 0 280px", display: "flex", flexDirection: "column", alignItems: "center" }}>
            <div className="gcse-search" style={{ width: "100%" }} />
          </div>

          {/* Right: Admission CTA */}
          <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 10 }}>
            <a href="/admissionprocedure" style={admissionBtnStyle}
              onMouseEnter={e => e.currentTarget.style.backgroundColor = "#8B0000"}
              onMouseLeave={e => e.currentTarget.style.backgroundColor = CRIMSON}
            >
              <FormOutlined style={{ fontSize: 13 }} />
              Admission Portal
            </a>
            <div style={{ display: "flex", gap: 10 }}>
              {[
                { label: "NAAC", href: "http://naac.gov.in/" },
                { label: "UGC", href: "https://www.ugc.ac.in/" },
                { label: "GU", href: "https://www.gauhati.ac.in/" },
              ].map(({ label, href }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    fontSize: 11,
                    fontWeight: 700,
                    color: NAVY,
                    textDecoration: "none",
                    padding: "3px 9px",
                    border: `1px solid ${GOLD}`,
                    borderRadius: 3,
                    letterSpacing: 0.5,
                    transition: "background 0.2s, color 0.2s",
                  }}
                  onMouseEnter={e => { e.currentTarget.style.background = GOLD; e.currentTarget.style.color = "#fff"; }}
                  onMouseLeave={e => { e.currentTarget.style.background = "transparent"; e.currentTarget.style.color = NAVY; }}
                >
                  {label}
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* ══════════════════════════════════════
            MEGA NAV BAR
        ══════════════════════════════════════ */}
        <MegaNavbar history={this.props.history} />

        {/* Mobile search */}
        <div className="search-google-box-mobile">
          <div className="gcse-search" />
        </div>
      </div>
    );
  }
}
